import React from 'react';
import ArticleCard from './ArticleCard';

const TrendingNow = ({ articles, title }) => {
    return (
        <section className="flex flex-col pb-4 mt-4 mb-0 w-full">
            <h2 className="text-3xl font-black leading-normal text-neutral-900">
                {title}
            </h2>
            <div className="flex flex-col lg:flex-row gap-4 mt-5">
                <ArticleCard article={articles[0]} isLarge={true} />
                <div className="flex flex-col grow px-0 lg:px-4 pb-2.5 lg:w-[576px] w-full">
                    {articles?.slice(1)?.map((article, index) => (
                        <ArticleCard key={index} article={article} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TrendingNow;
